import Vue from "vue";
import Router from "vue-router";
import LayoutPage from "../pages/layout/Index";
import ApiPage from "../pages/api/Index";
import DragDropPage from "../pages/drag/Index.vue";
import SchedulePage from "../pages/schedule/Index.vue";
import LibraryPage from "../pages/media/Library";
import MediaPage from "../pages/schedule/Repost.vue";
import LoginPage from "../pages/login/Index";
import MobilePage from "../pages/login/Moblie.vue";
import DesktopValidatePage from "../pages/login/DesktopValidate";
import AccountLayoutPage from "../pages/layout/Account";
import AddInstagramPage from "../pages/my_plan/AddInstagram";
import UnlimitedAutopostPage from "../pages/my_plan/UnlimitedAutopost";
import UpgradePage from "../pages/my_plan/Upgrade";
import MemberPage from "../pages/my_plan/Member";
import PaymentHistoryPage from "../pages/my_plan/History";
import SettingLayoutPage from "../pages/layout/Setting";
import SettingNotificationsPage from "../pages/setting/Notifications";
import SettingDefaultTimePage from "../pages/setting/DefaultTime";
import SettingAccountPage from "../pages/setting/Account";
import SettingDefaultCaptionPage from "../pages/setting/DefaultCaption";
import SettingManagerCaptionPage from "../pages/setting/ManagerCaption";
import SettingManagerSearchPage from "../pages/setting/ManagerSearch";
import ValidateHomePage from "../pages/validate/Home.vue";
import ValidateDownloadPage from "../pages/validate/Download.vue";
import DemoTabPage from "../pages/demo/common/Tab.vue";
import DemoMediaCaptionPage from "../pages/demo/media/Caption.vue";
import DemoMediaTagPage from "../pages/demo/media/Tag.vue";
import DemoCropPage from "../pages/demo/media/Crop";
import DemoVideoPage from "../pages/demo/media/Video";

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: "/",
      name: "LoginPage",
      component: LoginPage,
    },
    {
      path: "/posts/download",
      name: "ValidateDownloadPage",
      component: ValidateDownloadPage,
    },
    {
      path: "/posts/:token/home",
      name: "ValidateHomePage",
      component: ValidateHomePage,
    },
    {
      path: "/mobile",
      name: "MobilePage",
      component: MobilePage,
    },
    {
      path: "/desktop-validate",
      name: "DesktopValidatePage",
      component: DesktopValidatePage,
    },
    {
      path: "/api",
      name: "ApiPage",
      component: ApiPage,
    },
    {
      path: "/demo/tab",
      name: "DemoTabPage",
      component: DemoTabPage,
    },
    {
      path: "/demo/video",
      name: "DemoVideoPage",
      component: DemoVideoPage,
    },
    {
      path: "/demo/media/caption",
      name: "DemoMediaCaptionPage",
      component: DemoMediaCaptionPage,
    },
    {
      path: "/demo/media/tag",
      name: "DemoMediaTagPage",
      component: DemoMediaTagPage,
    },
    {
      path: "/demo/media/crop",
      name: "DemoCropPage",
      component: DemoCropPage,
    },
    {
      path: "/settings",
      name: "SettingLayoutPage",
      component: SettingLayoutPage,
      children: [
        {
          path: "account",
          name: "SettingAccountPage",
          component: SettingAccountPage,
        },
        {
          path: "notifications",
          name: "SettingNotificationsPage",
          component: SettingNotificationsPage,
        },
        {
          path: "default-time",
          name: "SettingDefaultTimePage",
          component: SettingDefaultTimePage,
        },
        {
          path: "default-caption-comment",
          name: "SettingDefaultCaptionPage",
          component: SettingDefaultCaptionPage,
        },
        {
          path: "manager-caption-comment",
          name: "SettingManagerCaptionPage",
          component: SettingManagerCaptionPage,
        },
        {
          path: "manager-search-repost",
          name: "SettingManagerSearchPage",
          component: SettingManagerSearchPage,
        },
      ],
    },
    {
      path: "/account",
      name: "AccountLayoutPage",
      component: AccountLayoutPage,
      children: [
        {
          path: "instagrams",
          name: "AddInstagramPage",
          component: AddInstagramPage,
        },
        {
          path: "premium-instagrams",
          name: "UnlimitedAutopostPage",
          component: UnlimitedAutopostPage,
        },
        {
          path: "members",
          name: "MemberPage",
          component: MemberPage,
        },
        {
          path: "plans",
          name: "UpgradePage",
          component: UpgradePage,
        },
        {
          path: "billing",
          name: "PaymentHistoryPage",
          component: PaymentHistoryPage,
        },
      ],
    },
    {
      path: "/layout",
      name: "LayoutPage",
      component: LayoutPage,
      children: [
        {
          path: "drag_drop",
          name: "DragDropPage",
          component: DragDropPage,
        },
        {
          path: "schedule",
          name: "SchedulePage",
          component: SchedulePage,
        },
        {
          path: "search_repost",
          name: "SearchRepostPage",
          component: MediaPage,
        },
        {
          path: "library",
          name: "LibraryPage",
          component: LibraryPage,
        },
        {
          path: "my_plan",
          name: "MyPlanPage",
          component: MediaPage,
        },
      ],
    },
  ],
});
